import axios from 'axios';
import AppSettings from '../appsettings';

const BASE_URL = `${AppSettings.API_BASE_URL}/appAnalytics`;

const appAnalyticsService = {
  // ✅ Get all analytics entries (admin)
  getAll: async () => {
    const response = await axios.get(BASE_URL);
    return response.data;
  },

  // ✅ Get all entries for a specific publisher
  getAllByPublisher: async (publisherId) => {
    const response = await axios.get(`${BASE_URL}/GetAllByPublisher`, {
      params: { publisherId },
    });
    return response.data;
  },

  // ✅ Get a single entry by ID
  getById: async (id) => {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // ✅ Create a new analytics entry
  create: async (analyticsData) => {
    const response = await axios.post(BASE_URL, analyticsData);
    return response.data;
  },

  // ✅ Update an analytics entry
  update: async (id, analyticsData) => {
    const response = await axios.put(`${BASE_URL}/${id}`, analyticsData);
    return response.status === 204;
  },

  // ✅ Delete an analytics entry
  delete: async (id) => {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.status === 204;
  },

  getRevenue: async (publisherId, fromDate, toDate, selectedApps, selectedWebs) => {
    const body = {
      publisherId,
      startDate: fromDate,
      endDate: toDate,
      selectedAppIds: selectedApps,
      selectedWebIds: selectedWebs,
    };

    const res = await axios.post(`${BASE_URL}/revenue`, body);
    return res.data;
  },
};

export default appAnalyticsService;
